export interface ItemAvailability {
  available: boolean;
  estimatedRefill?: string;
}

// Simulate random availability for menu items
const generateRandomAvailability = (): ItemAvailability => {
  const isAvailable = Math.random() > 0.2; // 80% chance of being available
  
  if (!isAvailable) {
    return {
      available: false,
      estimatedRefill: Math.random() > 0.5 ? 'Tomorrow morning' : 'Later today'
    };
  }
  
  return {
    available: true
  };
};

// Cache availability data to maintain consistency during session
const availabilityCache = new Map<string, ItemAvailability>();

export const getItemAvailability = (itemId: string): ItemAvailability => {
  if (!availabilityCache.has(itemId)) {
    availabilityCache.set(itemId, generateRandomAvailability());
  }
  return availabilityCache.get(itemId)!;
};

// Function to refresh availability (could be called periodically)
export const refreshAvailability = () => {
  availabilityCache.clear();
};

// Function to update specific item availability (for real-time updates)
export const updateItemAvailability = (itemId: string, availability: ItemAvailability) => {
  availabilityCache.set(itemId, availability);
};